<div *ngIf="error" class="content">
        <img class="unauthorized-image" src="../../../assets/images/unauthorized.png" alt="logo" *ngIf="!nordfab">
        <img class="unauthorized-image" src="../../../assets/images/unauthorized-nordfab.png" alt="logo" *ngIf="nordfab">
</div>